// extracted by mini-css-extract-plugin
module.exports = {"box":"CreateDirectoryInterpreterTab_box__3a3Te"};